import { aboutUsFeatures, aboutUsTools, get_lists, services } from '../constants/about_us';
import ScrollButton from '../components/scroll_button';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Layout from '../components/layout';
import styles from '../styles/about.module.scss';
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function About() {
  const router = useRouter();
  const { t } = useTranslation('about');

  const tools = aboutUsTools.filter(el => t(el.tool) !== '');
  
  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66'/>
      <section className={styles.first}>
        <h2>{t('titleAbout')}</h2>
        <div>
          <p>{t('aboutUsFeaturesDescription')}</p>
          <p>{t('aboutUsFeaturesTitle')}</p>
          <ul>
            {aboutUsFeatures.map( (el,id) => <li key={id} dangerouslySetInnerHTML={
              {__html: t(el.feature, { interpolation: { escapeValue: false }})}
            } />)}
          </ul>
          <p>{t('aboutUsToolsTitle')}</p>
          <ul>
            {tools.map( (el,id) => <li key={id}>{t(el.tool)}</li>)}
          </ul>
        </div>
      </section>
      <div className={styles.splitter}>
        <img src='/about/splitter.webp' alt={t("splitterAlt")} />
      </div>
      <section className={styles.what_get}>
        <h2>{t('what_we_get.title')}</h2>
        <div className={styles.list}>
          {
            get_lists.map((item, key) => <div className='flex col' key={key}>
              <Image src={item.img} layout='fixed' alt={item.title || ''} />
              <p>{t(item.title)}</p>
            </div>)
          }
        </div>
      </section>

      <section className={styles.best_in_cloud}>
        <img src='/about/best_cloud_bg.webp' className={styles.best_in_cloud_bg} alt='Best cloud background' loading='lazy' />
        <div className={styles.best_in_cloud_content}>
          <h3 dangerouslySetInnerHTML={{ __html: t('best_cloud.title', { interpolation: { escapeValue: false } }) }} />
          <div>
            { (new Array(8).fill('')).map((item, key) => <p key={key}>{t(`best_cloud.description${key + 1}`)}</p>) }
            <p className={styles.read_more} dangerouslySetInnerHTML={{ __html: t('best_cloud.read_more', { interpolation: { escapeValue: false } }) }} />
          </div>
        </div>
        <img src='/about/best_cloud_img.webp' className={styles.best_in_cloud_img} alt='Best cloud background' loading='lazy' />
      </section>

      <section className={styles.last}>
        <h2>{t('contacts')}</h2>
        <p>Email: info@icdc.io</p>
        <h2>{t('learn_more_about_products')}</h2>
        <div className={'grid ' + styles.services}>
          {
            services.map((service, index) => <Link key={index} href={service.link}>
              <a>
                <div className={styles.service} key={service.title}>
                  <div>
                    <Image src={service.img} layout='fixed' alt="" loading='lazy' />
                  </div>
                  <p>{service.name}</p>
                </div>
              </a>
            </Link>
            )
          }
        </div>
      </section>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['about', 'common']),
  },
});
